import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';

@Component({
	selector: 'page-contact',
  	templateUrl: 'contact.html'
})
export class ContactPage {
	constructor(private navCtrl: NavController) {
	}
}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts